module.exports = __webpack_public_path__ + "static/img/banner.5696868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/Support/banner.png
// module id = ek7i
// module chunks = 0